import { ChangeDetectionStrategy, Component } from '@angular/core'
import { AsyncPipe } from '@angular/common'
import { map } from 'rxjs'
import { PaymentStatusHelper } from "@features/open-banking/status/status-helper.service"
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from "@angular/material/dialog"
import { MatButton } from "@angular/material/button"
import { MatIcon } from "@angular/material/icon"

@Component({
    selector: 'app-payment-status',
    templateUrl: './payment-status.component.html',
    styleUrls: ['./payment-status.component.scss'],
    imports: [
        AsyncPipe,
        MatDialogContent,
        MatDialogTitle,
        MatButton,
        MatIcon,
        MatDialogActions,
        MatDialogClose,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentStatusComponent {
  readonly isSuccessful$ = this.statusHelper.isSuccessful$

  readonly isFailed$ = this.statusHelper.isFailed$

  readonly icon$ = this.isFailed$.pipe(
    map((isFailed) => {
        return isFailed ? 'close' : 'task_alt'
    }
  ))

  readonly iconColor$ = this.isFailed$.pipe(
    map((isFailed) => {
        return isFailed ? 'warn' : 'primary'
      }
    ))

  constructor(
    private statusHelper: PaymentStatusHelper,
  ) {
  }
}
